export default __webpack_public_path__ + "static/media/countries.1b313da5.svg";